// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__EbMXY","overlay":"Spinner_overlay__3m6fA"};